import { Backdrop, Box, Button, CircularProgress, Dialog, IconButton, InputAdornment, MenuItem, Snackbar, Stack, TableCell, TextField, Typography } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../App";
import { API } from "../conf";
import { Close, Delete, Edit, InfoOutlined, Search } from "@mui/icons-material";
import SorTable from "../Components/ui/sortable.js";
import UserForm from "./user-form";
import Header from "../Components/layout/Header.js";
import { access_list } from "../asset/variables.js";

export default function Users() {
    const {updateConnect} = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    
    const [load, setLoad] = useState(false)
    const [users, setUsers] = useState([])
    const [search, setShearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [user, setUser] = useState()
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [reinit, setReinit] = useState(false)

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Prénoms", sortable: true, sortBy:(el)=>(el.prenom1+' '+el.prenom2).toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.prenom1+' '+row.prenom2}</TableCell>},
        {header: "Mail", sortable: true, sortBy:(el)=>el.mail, row: (row, index)=><TableCell key={index}>{row.mail}</TableCell>},
        {header: "Identifiant", sortable: true, sortBy:(el)=>el.identifiant, row: (row, index)=><TableCell key={index}>{row.identifiant}</TableCell>},
        {header: "Organisation", sortable: true, sortBy:el=>(el.organisation.nom+' '+el.organisation.commune).toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.organisation.nom+' - '+row.organisation.commune}</TableCell>},
        {header: "Rôle", sortable: true, sortBy:(el)=>el.role.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', textAlign:'center'}}>{row.role}</TableCell>},
        {header: "Status", sortable: true, sortBy:(el)=>el.active, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', textAlign:'center'}}>{row.active?'Activé':'Non activé'}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} align="right" sx={{minWidth:'110px'}} >
            <IconButton aria-label="modifier" onClick={()=>{setUser(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="informations complémentaires" onClick={()=>{setUser(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" disabled={agent._id===row._id} onClick={()=>{setUser(row); manage_dialog(true, 'delete')}}><Delete fontSize="small"/></IconButton>
        </TableCell>}
    ]

    const eglise = useMemo(()=>organisation&&organisation.type==='église' ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.prenom1+' '+item.prenom2+' '+item.mail+' '+item.identifiant+' '+item.eglises.map(eglise=>eglise.nom+' '+eglise.commune).join(' ')+' '+item.role
    }

    function manage_dialog(status, action) {
        setOpen(status); setAction(action)
        if (!status) {
            setUser()
        } 
    }

    function handleReinitMdp() {
        setLoad(true)
        fetch(API.concat(`/users/${user._id}/mdp`), {method:'HEAD', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setReinit(true)
                } setLoad(false)
            }
        })
    }

    async function handleDelete(users) {
        setLoad(true)
        fetch(API.concat('/users'), {method:'DELETE', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({ids: users})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setUsers(old=> old.filter(usr=>!users.includes(usr._id)))
                    manage_dialog(false, '')
                } setLoad(false)
            }
        })
    }

    function getAllUsers() {
        setLoad(true); setEgliseId('tous')
        fetch(API.concat('/users'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {users, eglises} = await response.json()
                    
                    Promise.all(users.map(user=>{return new Promise((resolve, reject) => {
                        user.eglises = eglises.filter(eg=> user.eglises.includes(eg.number))
                        user.organisation = eglises.find(e=> e.number===user.organisation)
                        resolve(user)
                    })})).then(usrs=>{
                        setUsers(usrs); setLoad(false)
                    })
                }else setLoad(false)
            }
        })
    }

    useEffect(()=>{
        if(eglise){
            setLoad(true)
            fetch(API.concat(`/users/eglises/by/${JSON.stringify({level:{$lt: agent.level}, $or:[{eglises:eglise.number}, {organisation:eglise?.number}]})}`), 
            {method:'GET', headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }}).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const {users, eglises} = await response.json();
                        
                        Promise.all(users.map(user=>{return new Promise((resolve, reject) => {
                            user.eglises = eglises.filter(eg=> user.eglises.includes(eg.number))
                            user.organisation = eglises.find(e=> e.number===user.organisation)
                            resolve(user)
                        })})).then(usrs=>{
                            setUsers(usrs); setLoad(false)
                        })
                    }else setLoad(false)
                }
            })
        }
    }, [eglise, agent])

    useEffect(()=>{
        if(organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:agent.level>=4?{type: {$in: ['église', 'fédération']}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation, agent])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[]) 

    return(
        <Box display='flex' flex={1} flexDirection='column' marginBottom='30px'>
            <Header/>
            <Typography variant="h4" align="center" marginY={5}>Gestion des utilisateurs</Typography>

            {organisation&&organisation.type==='fédération'&&
            <TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} 
            onChange={e=>e.target.value==='tous'?getAllUsers():setEgliseId(old=>{if(old!==e.target.value)setUsers([]); return e.target.value})}>
                {eglises.length>1&&<MenuItem value={'tous'}>Tous les utilisateurs</MenuItem>}
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}

            {(eglise||egliseId==='tous')&&
            <Box display='flex' justifyContent='space-between' alignItems='center' marginX='30px'>
                <TextField placeholder="Rechercher un utilisateur" size="small" sx={{width:'60%', minWidth:'400px'}} value={search} onChange={e=>setShearch(e.target.value)}
                InputProps={{endAdornment: (<InputAdornment position="end"><Search /></InputAdornment>)}}/>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <Button variant="contained" disabled={selectItems.length<=0||users.some(usr=> selectItems.includes(usr._id)&&usr._id===agent._id)} onClick={()=>manage_dialog(true, 'delete many')}>supprimer</Button>
                    <Button variant="contained" onClick={()=>manage_dialog(true, 'add')}>Ajouter</Button>
                </Stack>
            </Box>}

            {(eglise||egliseId==='tous')&&<div style={{marginInline:'30px'}}><SorTable data={users.filter(log=> normalize(get_searchable(log)).includes(normalize(search)))} selectItems={selectItems} setItems={setItems} table={table} rowsPerPage={100} rowsPerPageOptions={[25, 50, 100, 300]}/></div>}

            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Dialog open={open} fullWidth maxWidth={['add', 'edit'].includes(action)?'md':'xs'} onClose={()=>manage_dialog(false, '')}>
                <IconButton onClick={()=>manage_dialog(false, '')} sx={{alignSelf:'end', marginTop:'5px', marginRight:'5px'}}><Close/></IconButton>
                {action==='info'&& <Box display='flex' flexDirection='column' marginX='20px' marginBottom='20px'>
                    <Typography variant="h6" align="center" marginBottom='10px' style={{textTransform:'capitalize'}}>{user.nom+' '+user.prenom1+' '+user.prenom2}</Typography>
                    {user.eglises.length>0&&<Typography variant="subtitle1" marginTop='5px'>Églises à charge: </Typography>}
                    {user.eglises.map(eglise=><Typography key={eglise._id} marginLeft='20px' textTransform='capitalize'>- {eglise.nom+' - '+eglise.commune}</Typography>)}
                    <Typography variant="subtitle1"  marginTop='5px'>Liste d'accès:</Typography>
                    {user.access.map(acces=><Typography key={acces} marginLeft='20px'>- {access_list.find(acl=> acl.ref===acces)?.label}</Typography>)}
                    <Button sx={{alignSelf:'end'}} onClick={handleReinitMdp}>Réinitialiser le mot de passe</Button>
                </Box>}
                {action==='add'&& <UserForm {...{eglise, add:usr=>{if(egliseId==='tous'||[...usr.eglises.map(eg=>eg.number),usr.organisation.number].includes(eglise.number))setUsers(old=>[...old, usr])}, close:()=>manage_dialog(false, '')}} />}
                {action==='edit'&&user&& <UserForm {...{eglise, edit:true, user, add:usr=>setUsers(old=>[...old.filter(u=>u._id!==usr._id), (egliseId==='tous'||[...usr.eglises.map(eg=>eg.number),usr.organisation.number].includes(eglise?.number))?usr:''].filter(us=>us!=='')), close:()=>manage_dialog(false, '')}} />}
                {action==='delete'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center" textTransform='capitalize'>Supprimer {[user.nom, user.prenom1, user.prenom2].filter(nm=>nm!=='').join(' ')} ({user.role})</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete([user._id])}>supprimer</Button>
                    </Stack>
                </Box>}
                {action==='delete many'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">Supprimer {selectItems.length>1 ? `les ${selectItems.length} ` : "l'"}utilisateur{selectItems.length>1&&'s'}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete(selectItems)}>supprimer</Button>
                    </Stack>
                </Box>}
            </Dialog>

            <Snackbar
            open={reinit}
            autoHideDuration={3500}
            onClose={()=>setReinit(false)}
            message="Mail de réinitialisation envoyé ✓"
            />
        </Box>
    )
}